import Id from './Id';
import Status from './Status';
import Supplier from './Supplier';
import CreatorUser from './CreatorUser';
import TargetStorage from './TargetStorage';
import SourceStorage from './SourceStorage';
import ReceiptNumber from './ReceiptNumber';
import NetPrice from './NetPrice';
import GrossPrice from './GrossPrice';
import Currency from './Currency';
import Customer from './Customer';
import Type from './Type';
import IsStockist from './IsStockist';
import Created from './Created';
import Updated from './Updated';
import CmDeliveryNoteNumber from './CmDeliveryNoteNumber';

export const compareTypes = {
  net_price: 'number',
  gross_price: 'number',
};

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  CmDeliveryNoteNumber: 'CM szlev száma',
  Status: 'Státusz',
  Supplier: 'Eladó',
  IsStockist: 'Besz. ár végleges',
  SourceStorage: 'Szállító raktár',
  TargetStorage: 'Átvevő raktár',
  CreatorUser: 'Rögzítette',
  NetPrice: 'Nettó ár',
  GrossPrice: 'Bruttó ár',
  Currency: 'Deviza',
  Customer: 'Átvevő',
  Type: 'Típus',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Supplier',
}, {
  value: 'Customer',
}, {
  value: 'IsStockist',
}, {
  value: 'SourceStorage',
}, {
  value: 'TargetStorage',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
}, {
  value: 'Type',
}, {
  value: 'Currency',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'CmDeliveryNoteNumber',
}, {
  value: 'Status',
}, {
  value: 'IsStockist',
}, {
  value: 'Type',
}, {
  value: 'Supplier',
}, {
  value: 'SourceStorage',
}, {
  value: 'CreatorUser',
}, {
  value: 'TargetStorage',
}, {
  value: 'Customer',
}, {
  value: 'NetPrice',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  CmDeliveryNoteNumber,
  Status,
  Supplier,
  SourceStorage,
  TargetStorage,
  CreatorUser,
  NetPrice,
  GrossPrice,
  Type,
  Customer,
  Created,
  IsStockist,
  Updated,
  Currency,
};
